import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Input,
  Label,
  Stack,
  Text,
} from '@shared/ui';

export function InputShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.primitives.input.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.primitives.input.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Stack gap="xs" className="space-y-2">
          <Label htmlFor="ui-library-input-basic">
            {t('uiLibrary.primitives.input.basicLabel')}
          </Label>
          <Input
            id="ui-library-input-basic"
            placeholder={t('uiLibrary.primitives.input.placeholder')}
          />
        </Stack>

        <Stack gap="xs" className="space-y-2">
          <Label htmlFor="ui-library-input-error">
            {t('uiLibrary.primitives.input.errorLabel')}
          </Label>
          <Input
            id="ui-library-input-error"
            placeholder={t('uiLibrary.primitives.input.placeholder')}
            className="border-destructive focus-visible:ring-destructive"
            aria-invalid="true"
          />
          <Text size="xs" color="destructive">
            {t('uiLibrary.primitives.input.errorText')}
          </Text>
        </Stack>
      </CardContent>
    </Card>
  );
}
